import { render, staticRenderFns } from "./ed-designer-menu.component.vue?vue&type=template&id=58f63ae4&scoped=true&"
import script from "./ed-designer-menu.component.ts?vue&type=script&lang=ts&"
export * from "./ed-designer-menu.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-designer-menu.component.scss?vue&type=style&index=0&id=58f63ae4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f63ae4",
  null
  
)

export default component.exports